// extracted by mini-css-extract-plugin
export default {"summary":"VeggiesSummary_summary__xcuFI"};